import { Injectable } from '@angular/core';
import { TranslateMessageFormatCompiler } from 'ngx-translate-messageformat-compiler';

@Injectable()
export class TranslateICUCompiler extends TranslateMessageFormatCompiler {
  public compile(value: string, lang: string): (params: unknown) => string {
    return super.compile(value, lang);
  }
  public compileTranslations<T>(translations: T, lang: string): T {
    try {
      const compiled = super.compileTranslations(translations, lang);
      return compiled;
    } catch (ex) {
      // eslint-disable-next-line no-console
      console.error(ex);
    }

    return translations;
  }
}
